import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuth } from './context/AuthContext'
import Login from './pages/Login'
import SetPassword from './pages/SetPassword'

// Split the two app shells into separate chunks — portal clients never
// download the coach/admin bundle and vice versa
const Dashboard = lazy(() => import('./pages/Dashboard'))
const PortalLayout = lazy(() => import('./pages/portal/PortalLayout'))

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-off-white flex items-center justify-center">
      <div className="bg-navy p-12 rounded-lg text-center flex flex-col items-center">
        <img src="/4lc-logo.png" alt="4 Level Compass" className="w-96 mb-6" />
        <p className="font-inter text-brand-grey text-sm tracking-widest uppercase">
          Loading...
        </p>
      </div>
    </div>
  )
}

function App() {
  const { user, profile, loading, passwordRecovery } = useAuth()

  if (loading) {
    return <LoadingScreen />
  }

  const isClient = user && profile?.role === 'client'

  return (
    <BrowserRouter>
      {/* react-hot-toast renders nothing without a Toaster mounted. There was
          never one, so every toast.success / toast.error in the app — around
          forty of them, including every "could not save" — has been silently
          doing nothing. Found 2026-09-30 while testing the Credit Menu: a save
          was failing and the UI said nothing at all. */}
      <Toaster
        position="top-right"
        toastOptions={{
          style: { fontFamily: 'Inter, sans-serif', fontSize: '13px' },
          success: { duration: 3000 },
          error: { duration: 6000 },
        }}
      />
      <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/" replace />} />
        <Route path="/set-password" element={
          user ? <SetPassword /> : <Navigate to="/login" replace />
        } />
        <Route path="/reset-password" element={
          user ? <Navigate to="/set-password" replace /> : <Navigate to="/login" replace />
        } />
        {user && passwordRecovery ? (
          <Route path="*" element={<Navigate to="/set-password" replace />} />
        ) : isClient ? (
          <>
            <Route path="/portal/*" element={<PortalLayout />} />
            <Route path="*" element={<Navigate to="/portal" replace />} />
          </>
        ) : (
          <Route path="/*" element={user ? <Dashboard /> : <Navigate to="/login" replace />} />
        )}
      </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
